import * as React from 'react';
import { memo } from 'react';

import { WithVirtualPageView } from 'components/hoc/withVirtualPageView';
import { routes } from 'defs';
import VirtualPageViewFields from 'defs/ga/fields/virtualPageView';

import withVirtualPageView from 'components/hoc/withVirtualPageView';
import Rich from 'components/molecules/Rich';

const Error40x = ({ trackVirtualPageView }: WithVirtualPageView) => {
	const errorConfig = routes.error40x.indexRoute.config || ({} as any);
	const title: string = errorConfig.title;
	const subtitle: string = errorConfig.subtitle;
	const text: string = errorConfig.text;

	trackVirtualPageView({
		[VirtualPageViewFields.HTTPResponseCode]: 404,
	});

	return (
		<div className="container">
			<div className="row">
				<div className="col-xs-12">
					<div className="a-error-40x">
						<h1 className="a-error-40x__headline">{title}</h1>
						<h3 className="a-error-40x__title">{subtitle}</h3>
						<Rich contents={text} />
					</div>
				</div>
			</div>
		</div>
	);
};

Error40x.displayName = 'Error40x';

export { Error40x };

export default withVirtualPageView(memo(Error40x)) as any;
